import { BILLINGLIST_INDEX, BILLINGLIST_SHOW, BILLINGLIST_SAVE } from '../actions/billingList'
import apiCall from '../../utils/api'

const state = {
  billinglists: []
}

const getters = {
  [BILLINGLIST_INDEX]: (state, getters) => {
    return state.billinglists
  }
}

const actions = {
  [BILLINGLIST_INDEX]: ({commit, dispatch}) => {
    return new Promise((resolve, reject) => {
      apiCall({url: 'api/billingLists', method: 'GET'})
        .then(resp => {
          commit(BILLINGLIST_INDEX, resp)
          resolve(resp)
        })
    })
  },
  [BILLINGLIST_SAVE]: ({commit, dispatch}, data) => {
    return new Promise((resolve, reject) => {
      apiCall({url: 'api/billingLists/' + data.id, method: 'PUT', ...data}).then(resp => {
        resolve(resp)
      }).catch(err => {
        reject(err)
      })
    })
  },
  [BILLINGLIST_SHOW]: ({commit, dispatch}, id) => {
    return new Promise((resolve, reject) => {
      apiCall({url: 'api/billingLists', method: 'GET'})
        .then(resp => {
          console.log('asdasd')
          let billinglist = resp.find((billinglist) => {
            return billinglist.id === parseInt(id)
          })
          resolve(billinglist)
        })
    })
  }
}

const mutations = {
  [BILLINGLIST_INDEX]: (state, resp) => {
    state.billinglists = resp
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/billingList.js